import { prop } from 'ramda';
import { createSelector } from 'reselect';

export const getCarDestination = prop('carDestination');
export const getPreferredDestination = createSelector(
  getCarDestination,
  prop('address'),
);
export const getIsUnknownDestination = createSelector(
  getCarDestination,
  prop('isUnknownDestination'),
);
